import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useHistory} from "react-router-dom";
import {Archive, Flag, Gavel, Settings} from "lucide-react";
import {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const CommunityModOptionsSheet = styled(({className, community, onClose}) => {

    const history = useHistory();

    const handleQueue = () => {
        history.push(`/c/${community}/queue`);
    };

    const handleLogs = () => {
        history.push(`/c/${community}/logs`);
    };

    const handleSettings = () => {
        history.push(`/c/${community}/config/settings`);
    };

    const handleBans = () => {
        history.push(`/c/${community}/ban`);
    };

    return (
        <div className={className}>
            <MenuItem onClick={handleSettings}>
                <MenuItemIcon>
                    <Settings size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Settings
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleBans}>
                <MenuItemIcon>
                    <Gavel size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Bans
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleQueue}>
                <MenuItemIcon>
                    <Flag size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Queue
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleLogs}>
                <MenuItemIcon>
                    <Archive size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Logs
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default CommunityModOptionsSheet;
